import { useState } from 'react';
import HomeButton from './shared/HomeButton';
import KnowledgeFilters from './knowledge/KnowledgeFilters';
import CollectionListItem from './knowledge/CollectionListItem';
import IssuesSection from './knowledge/IssuesSection';
import ItemDetailsSection from './knowledge/ItemDetailsSection';
import NotificationDropdown from './NotificationDropdown';
import CreateItemModal from './knowledge/CreateItemModal';
import NotificationBanners from './shared/NotificationBanners';

export default function KnowledgeSidebar({
  searchTerm,
  setSearchTerm,
  selectedProduct,
  setSelectedProduct,
  selectedCategory,
  setSelectedCategory,
  filteredCollections,
  selectedCollections,
  lockedCollectionId,
  handleCollectionClick,
  issues,
  contextFilters,
  onRemoveFilter,
  onAddFilter,
  selectedItem,
  onCloseItemDetails,
  onUpdateItem,
  products = [],
  categories = [],
  onDeleteCollection,
  onUnselectCollection,
  onRefreshCollections,
  collections = [],
  onCreateProduct
}) {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  // Sort collections: locked collection first, then the rest
  const sortedCollections = [...filteredCollections].sort((a, b) => {
    if (a.id === lockedCollectionId) return -1;
    if (b.id === lockedCollectionId) return 1;
    return 0;
  });
  return (
    <div className="h-full flex flex-col relative">
      {/* Header with Title and Home Button */}
      <div className="h-16 border-b border-gray-700 px-4 pr-12 flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <HomeButton />
          <h1 className="text-xl font-bold text-white">Knowledge</h1>
        </div>
        <NotificationDropdown align="left" />
      </div>

      {/* Filters */}
      <div className="p-4 border-b border-gray-700 flex-shrink-0">
        <KnowledgeFilters
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          selectedProduct={selectedProduct}
          setSelectedProduct={setSelectedProduct}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          contextFilters={contextFilters}
          onRemoveFilter={onRemoveFilter}
          products={products}
          categories={categories}
        />
      </div>

      {/* Notification Banners (includes import progress) */}
      <NotificationBanners onCreateProduct={onCreateProduct} onRefresh={onRefreshCollections} />

      {/* Collection Count Header - Fixed */}
      <div className="px-4 py-2 border-b border-gray-700/50 flex-shrink-0">
        <p className="text-xs text-gray-500 font-semibold">
          {filteredCollections.length} {filteredCollections.length === 1 ? 'Collection' : 'Collections'}
        </p>
      </div>

      {/* Collections List - Scrollable */}
      <div className="flex-1 overflow-y-auto">
        {/* Collections or Empty State */}
        {filteredCollections.length === 0 ? (
          <div className="text-center py-8">
            <svg className="w-12 h-12 mx-auto mb-3" style={{ color: 'var(--color-text-disabled)' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            <p className="text-sm" style={{ color: 'var(--color-text-muted)' }}>No collections yet</p>
            <p className="text-xs mt-1" style={{ color: 'var(--color-text-disabled)' }}>Create a new collection to begin</p>
          </div>
        ) : (
          <div className="p-4 space-y-2">
            {sortedCollections.map((collection) => (
              <CollectionListItem
                key={collection.id}
                collection={collection}
                isSelected={selectedCollections.includes(collection.id)}
                isLocked={collection.id === lockedCollectionId}
                onClick={() => handleCollectionClick(collection.id)}
                onAddFilter={onAddFilter}
                onDeleteCollection={onDeleteCollection}
                onUnselectCollection={onUnselectCollection}
              />
            ))}
          </div>
        )}
      </div>

      {/* Item Details Section */}
      <ItemDetailsSection item={selectedItem} onClose={onCloseItemDetails} onUpdate={onUpdateItem} />

      {/* Issues Section */}
      <IssuesSection issues={issues} />

      {/* Create Item Modal */}
      <CreateItemModal
        isOpen={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
        collections={collections}
        onItemCreated={() => {
          setIsCreateModalOpen(false);
          if (onRefreshCollections) {
            onRefreshCollections();
          }
        }}
      />
    </div>
  );
}
